import React from 'react';
import Navbar from '../components/Navbar';
import { Link } from 'react-router-dom';
import { Scales } from '@phosphor-icons/react';

export default function Terms() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="max-w-3xl mx-auto px-4 py-16">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 border-2 border-foreground bg-primary shadow-brutal mb-4 rotate-3">
            <Scales size={32} weight="bold" color="white" />
          </div>
          <h1 className="font-display text-4xl md:text-6xl font-bold tracking-tight">SYARAT & <span className="text-primary italic">KETENTUAN</span></h1>
          <p className="text-foreground/60 mt-2 uppercase tracking-widest text-xs font-bold">Terakhir diperbarui: April 2026</p>
        </div>

        <div className="space-y-8 text-sm leading-relaxed text-foreground/80">
          <section className="border-2 border-foreground bg-white p-6 shadow-brutal-sm">
            <h2 className="font-display text-xl font-bold text-foreground mb-3">1. Ketentuan Umum</h2>
            <p>Dengan menggunakan layanan Traktirkan ("Platform"), Anda menyetujui untuk terikat dengan syarat dan ketentuan ini. Platform ini menyediakan layanan penerimaan dukungan finansial (traktiran) dari audiens ke kreator melalui sistem pembayaran digital. Jika Anda tidak menyetujui ketentuan ini, mohon untuk tidak menggunakan Platform.</p>
          </section>

          <section className="border-2 border-foreground bg-white p-6 shadow-brutal-sm">
            <h2 className="font-display text-xl font-bold text-foreground mb-3">2. Pendaftaran Akun</h2>
            <ul className="list-disc ml-4 space-y-2">
              <li>Anda harus berusia minimal 17 tahun atau sudah memiliki KTP untuk membuat akun kreator.</li>
              <li>Informasi yang diberikan saat pendaftaran harus akurat dan terkini.</li>
              <li>Setiap orang hanya boleh memiliki satu akun kreator aktif.</li>
              <li>Anda bertanggung jawab penuh atas keamanan akun dan kata sandi Anda.</li>
            </ul>
          </section>

          <section className="border-2 border-foreground bg-white p-6 shadow-brutal-sm">
            <h2 className="font-display text-xl font-bold text-foreground mb-3">3. Biaya Layanan</h2>
            <ul className="list-disc ml-4 space-y-2">
              <li>Platform memotong biaya layanan sebesar <strong>3%</strong> dari setiap traktiran yang berhasil.</li>
              <li>Biaya payment gateway (QRIS/E-Wallet) ditanggung oleh donatur.</li>
              <li>Tidak ada biaya pendaftaran, biaya bulanan, atau biaya tersembunyi lainnya.</li>
              <li>Platform berhak mengubah struktur biaya dengan pemberitahuan minimal 30 hari sebelumnya.</li>
            </ul>
          </section>

          <section className="border-2 border-foreground bg-white p-6 shadow-brutal-sm">
            <h2 className="font-display text-xl font-bold text-foreground mb-3">4. Penarikan Dana</h2>
            <ul className="list-disc ml-4 space-y-2">
              <li>Penarikan dana dapat dilakukan ke rekening bank lokal di Indonesia.</li>
              <li>Minimum penarikan adalah Rp 10.000.</li>
              <li>Proses penarikan membutuhkan waktu 1-3 hari kerja.</li>
              <li>Kreator bertanggung jawab atas kewajiban pajak yang timbul dari pendapatan yang diterima.</li>
            </ul>
          </section>

          <section className="border-2 border-foreground bg-white p-6 shadow-brutal-sm">
            <h2 className="font-display text-xl font-bold text-foreground mb-3">5. Konten & Penggunaan</h2>
            <ul className="list-disc ml-4 space-y-2">
              <li>Kreator dilarang menggunakan Platform untuk aktivitas ilegal, penipuan, atau perjudian.</li>
              <li>Konten yang melanggar hukum Indonesia atau mengandung SARA dilarang keras.</li>
              <li>Platform berhak menonaktifkan akun yang melanggar ketentuan tanpa pemberitahuan.</li>
              <li>Pesan donasi yang mengandung kata-kata kasar akan difilter secara otomatis oleh sistem moderasi.</li>
            </ul>
          </section>

          <section className="border-2 border-foreground bg-white p-6 shadow-brutal-sm">
            <h2 className="font-display text-xl font-bold text-foreground mb-3">6. Overlay & Fitur Streaming</h2>
            <ul className="list-disc ml-4 space-y-2">
              <li>Token overlay bersifat rahasia dan merupakan tanggung jawab kreator untuk menjaganya.</li>
              <li>Platform tidak bertanggung jawab atas konten media yang dikirim melalui fitur Media Share.</li>
              <li>Kreator wajib memastikan penggunaan overlay sesuai dengan ketentuan platform streaming (OBS, Streamlabs, dll).</li>
            </ul>
          </section>

          <section className="border-2 border-foreground bg-white p-6 shadow-brutal-sm">
            <h2 className="font-display text-xl font-bold text-foreground mb-3">7. Pembatasan Tanggung Jawab</h2>
            <p>Platform disediakan "sebagaimana adanya" tanpa jaminan. Kami tidak bertanggung jawab atas kerugian langsung atau tidak langsung yang timbul dari penggunaan Platform, termasuk namun tidak terbatas pada kehilangan pendapatan, gangguan layanan, atau akses tidak sah ke akun Anda.</p>
          </section>

          <section className="border-2 border-foreground bg-white p-6 shadow-brutal-sm">
            <h2 className="font-display text-xl font-bold text-foreground mb-3">8. Kontak</h2>
            <p>Untuk pertanyaan mengenai syarat dan ketentuan ini, hubungi kami melalui email di <strong>legal@traktirkan.com</strong> atau melalui fitur Pusat Bantuan di Platform.</p>
          </section>
        </div>

        <div className="mt-12 text-center text-xs text-muted-foreground">
          <p>Lihat juga: <Link to="/privacy" className="text-primary hover:underline font-bold">Kebijakan Privasi</Link></p>
        </div>
      </main>
    </div>
  );
}
